import { render } from "./NotFound.vue?vue&type=template&id=9184ad64"
const script = {}

import exportComponent from "D:\\workspace\\VUE_Tuts\\cybershyft\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__